import { ReactNode, useState, isValidElement } from 'react';
import { IconQuestionMarkFilled } from '@iwoca/icons';
import clsx from 'clsx';
import { useReviewOffer } from 'components/ReviewOffer/ReviewOffer.context';
import { Offer } from 'components/SummaryCard/SummaryCard.helpers';
import { Tooltip } from 'react-tooltip';
import { v4 } from 'uuid';
import styles from '../../SummaryCard.module.css';

type TooltipProps = {
  tooltipText?: string | ReactNode;
  tooltipTestId?: string;
};

export const LabelTooltip = ({ tooltipText, tooltipTestId }: TooltipProps) => {
  const { offerDecision } = useReviewOffer();
  const [copyId] = useState(v4());

  if (!tooltipText) {
    return null;
  }

  return (
    <div
      className={clsx(styles.tooltipWrapper, {
        [styles.unselectedValue]: offerDecision === Offer.REJECT,
      })}
      data-testid={tooltipTestId}
      data-tooltip-id={copyId}
    >
      <IconQuestionMarkFilled
        height={16}
        width={16}
        className={styles.helpIcon}
      />
      <Tooltip
        className={styles.tooltip}
        id={copyId}
        opacity={1}
        openEvents={{ focus: false, mouseenter: true }}
        border="1px solid var(--color-structure-80)"
        place="bottom"
        clickable={isValidElement(tooltipText)}
      >
        <div>{tooltipText}</div>
      </Tooltip>
    </div>
  );
};
